
// import { AreawiseModel, ID, Response } from "../../../../../../_metronic/helpers"

import { AreawiseModel, ID, Response } from "../../../../../../_metronic/helpers"

export type Areawise = {
  id?: ID
  name?: string
  booking_name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type AreawisesQueryResponse = Response<Array<AreawiseModel>>

export const initialAreawise: Areawise = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
